import { render, staticRenderFns } from "./ownerInfo.vue?vue&type=template&id=098e54ac&scoped=true"
import script from "./ownerInfo.vue?vue&type=script&lang=js"
export * from "./ownerInfo.vue?vue&type=script&lang=js"
import style0 from "./ownerInfo.vue?vue&type=style&index=0&id=098e54ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098e54ac",
  null
  
)

export default component.exports